//SalesResultsHeading.tsx =================================================
import "../Util/Prototypes";

import * as CompReport from "./CompReport";
import * as Default from "../Default";
import * as DrawerMenu from "../Menus/DrawerMenu";
import * as GraLay from "../Util/GraLay";
import * as HeatMap from "./HeatMap";
import * as MainMap from "../MainMap";
import * as SalesResults from "./SalesResults";
import * as SalesSearch from "./SalesSearch";
import * as SalesSearchSettings from "./SalesSearchSettings";
import * as Search from "../Search/Search";
import * as Settings from "../Settings";
import * as Util from "../Util/Util";
import * as Util_App from "../Util/Util_App";

import { Button, Icon, ListItemIcon, ListItemText, Menu, MenuItem } from "@mui/material";

import React from "react";

//Render function.
interface iProps {
}

export function Render(props: iProps) {
   Util.logMsg("Top of SalesResultsHeading Render");
   const toolNames: string[] = SalesSearchSettings.ss.salesResultsTools.slice(0);  //Clone array.
   const numSel: number = SalesResults.getNumSelected();

   const moreToolNames: string[] = SalesSearchSettings.ss.salesResultsMoreTools.slice(0); //Clone array.
   if (!SalesSearch.activePIN || Settings.security.accessLevel < SalesSearchSettings.ss.accessLevel_report || numSel === 0) {
      moreToolNames.Remove("Comp Report");
   }

   const lay: Search.iLayer = SalesSearch.layer;

   //Set refresh method.
   const [ignored, refresh] = React.useReducer((x: number) => x + 1, 0);

   //Component did mount.
   React.useEffect(() => {
      //Util.logMsg("SalesResultsHeading mounted");
   }, []);

   //Build top menu buttons.
   function getMenuButton(toolName: string) {
      const jsx: JSX.Element[] = [];

      const styles2: Default.iStyles = {
         button: { marginTop: 2, marginBottom: 2 },
      };

      const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);
      const key: string = "salesResultsHeading_" + toolName;

      jsx.push(
         <Button key={key} style={styles2.button} variant="outlined" size="medium" color="primary" onClick={() => handleClick(toolName)} title={ti.tip} aria-label={toolName}>
            <Icon color="action">{ti.iconName}</Icon>
            <span style={{ marginLeft: 4 }}></span>
            {ti.label}
         </Button>,
      );
      return jsx;
   }

   //Build more action menu items.
   function getMoreMenuItem(toolName: string) {
      const jsx: JSX.Element[] = [];
      const ti: Settings.iToolInfo = Settings.getToolInfo(toolName);

      if (toolName === "Heat Map") {
         if (HeatMap.heatMapExists()) {
            ti.label = "Clear heat map";
            ti.tip = ti.label;
         }
      }
      const key: string = "salesResultsHeading_" + toolName;

      jsx.push(
         <MenuItem key={key} onClick={() => handleClick(toolName)}>
            <ListItemIcon><Icon style={{ color: ti.iconColor }}>{ti.iconName}</Icon></ListItemIcon>
            <ListItemText primary={ti.label} />
         </MenuItem>,
      );
      return jsx;
   }

   //Action button click event.
   function handleClick(tool: string) {
      setAnchorEl(null);

      if (tool === "Comp Report") {
         CompReport.render();

      } else if (tool === "Clear") {
         SalesSearch.clearAllResults();
         DrawerMenu.closeTool();

         if (DrawerMenu.prevToolName === "Sales Search") {
            DrawerMenu.prevToolClick(DrawerMenu.prevToolName);
         }

      } else if (tool === "Zoom all") {
         const mbr = Util_App.addMarginToMBR(lay.zoomAllMBR, true);
         MainMap.activeView.goTo(mbr, { duration: 1000 });

      } else if (tool === "Table View") {

      } else if (tool === "Heat Map") {
         if (HeatMap.heatMapExists()) {
            HeatMap.clearHeatMap();

         } else {
            GraLay.appPnt.removeAll();
            GraLay.appPntHighlight.removeAll();
            HeatMap.create();
         }
         refresh();

      } else if (tool === "CSV") {
         const csvData: string = Util_App.build_csv(SalesSearch.layer);
         Util.downloadCSV(SalesSearch.layer.name + ".csv", csvData);
      }
   }

   //Dropdown menu required functions.
   const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

   function setMenuAnchor(event: React.MouseEvent<HTMLButtonElement>) {
      setAnchorEl(event.currentTarget);
   }
   function handleClose() {
      setAnchorEl(null);
   }

   //Only 1 record selected.
   if (lay.totRec === 1) {
      toolNames.Remove("Zoom all");
   }

   //Render components
   const styles: Default.iStyles = {
      row1Container: { display: 'flex', alignItems: 'flex-start', justifyContent: 'space-around', flexWrap: 'wrap', marginTop: 7 },
      button: { marginTop: 2 },
   };

   return (
      <div style={styles.row1Container}>
         {toolNames.map(function (toolName: string, i: number) {
            if (!toolName.StartsWith(" ")) {
               return (getMenuButton(toolName));
            }
         })}

         <div>
            <Button style={styles.button} aria-controls="more-tools-menu" variant="outlined" color="primary" onClick={setMenuAnchor} title="More result tools" aria-haspopup="true">
               <Icon color="action">more_vert</Icon>
               <span style={{ marginLeft: 4 }}></span>
               More
            </Button>

            <Menu id="more-tools-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
               {moreToolNames.map(function (toolName: string, i: number) {
                  if (!toolName.StartsWith(" ")) {
                     return (getMoreMenuItem(toolName));
                  }
               })}
            </Menu>
         </div>

      </div>
   ); //end return.

} //end function.
